import React from 'react';
import { Mail, MessageCircle } from 'lucide-react';
import { LOGO_URL } from '../config/siteConfig';
import { useLanguage } from '../i18n/LanguageContext';

const XIcon = ({ className }) =>
<svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>;


export const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="border-t border-slate-800/50 py-12 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Left */}
          <div className="text-center md:text-left">
            <div className="flex items-center gap-3 justify-center md:justify-start mb-2">
              <div className="w-8 h-8 rounded-full overflow-hidden">
                <img
                  src={LOGO_URL}
                  alt="Petechtor Logo"
                  className="w-full h-full object-cover" />

              </div>
              <span className="text-sm font-bold text-white">PETECHTOR</span>
            </div>
            <p className="!text-sm text-slate-400">{t('footerCopyright')}</p>
            <p className="text-xs text-slate-500 mt-1">{t('footerDisclaimer')}</p>
            <div className="flex items-center justify-center md:justify-start gap-2 mt-2 text-xs text-slate-500">
              <a href="mailto:info@petechtor.com" target="_blank" rel="noopener noreferrer" className="hover:text-cyan-400 transition-colors">info@petechtor.com</a>
              <span>•</span>
              <a href="https://discord.com/channels/1426431079329566824" target="_blank" rel="noopener noreferrer" className="hover:text-cyan-400 transition-colors">Discord</a>
              <span>•</span>
              <a href="https://x.com/" target="_blank" rel="noopener noreferrer" className="hover:text-cyan-400 transition-colors">X / Twitter</a>
              <span>•</span>
              <a href="https://petechtor.com" target="_blank" rel="noopener noreferrer" className="hover:text-cyan-400 transition-colors">petechtor.com</a>
            </div>
          </div>

          {/* Right - Social Links */}
          <div className="flex items-center gap-4 text-sm">
            <a
              href="mailto:info@petechtor.com"
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center gap-2 text-slate-400 hover:text-cyan-400 transition-colors">

              <Mail className="w-4 h-4" />
              <span className="hidden sm:inline">info@petechtor.com</span>
            </a>
            <span className="text-slate-700">•</span>
            <a
              href="https://discord.com/channels/1426431079329566824"
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center gap-2 text-slate-400 hover:text-cyan-400 transition-colors">

              <MessageCircle className="w-4 h-4" />
              <span className="hidden sm:inline">Discord</span>
            </a>
            <span className="text-slate-700">•</span>
            <a
              href="https://x.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center gap-2 text-slate-400 hover:text-cyan-400 transition-colors">

              <XIcon className="w-4 h-4" />
              <span className="hidden sm:inline">X / Twitter</span>
            </a>
          </div>
        </div>
      </div>
    </footer>);

};